// extracted by mini-css-extract-plugin
module.exports = {"root":"Checkbox_root__xdHiB"};